/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, StyleProp, TextStyle, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, GProps, Path as SVG_Path, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="ManagementIcon">
 * <rect width="27" height="26" fill="white"/>
 * <path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M6.10023 8.53295C6.10023 12.6418 9.46945 16.0659 13.5125 16.0659C17.6904 16.0659 20.9248 12.6418 20.9248 8.53295C20.9248 4.42407 17.5556 1 13.5125 1C9.46945 1 6.10023 4.42407 6.10023 8.53295ZM7.44792 8.53295C7.44792 5.10888 10.1433 2.36963 13.5125 2.36963C16.8817 2.36963 19.5771 5.10888 19.5771 8.53295C19.5771 11.957 16.8817 14.6963 13.5125 14.6963C10.1433 14.6963 7.44792 11.957 7.44792 8.53295Z" fill="#373938"/>
 * <path id="Vector (Stroke)_2" fill-rule="evenodd" clip-rule="evenodd" d="M4.21371 25.2407C5.83133 21.5437 9.46957 19.0791 13.512 19.0791C17.5545 19.0791 21.1928 21.5438 22.8103 25.2409L22.811 25.2425L24.024 24.6946C23.9211 24.4631 23.8117 24.236 23.6963 24.0136C21.6946 20.1581 17.8442 17.7095 13.512 17.7095C9.17974 17.7095 5.32936 20.1581 3.32767 24.0136C3.21221 24.236 3.1029 24.4631 3 24.6946L4.21292 25.2425L4.21371 25.2407Z" fill="#373938"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const ManagementIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { svgRef } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 27 26" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="ManagementIcon">
        <Path
          fill="white"
          id="ManagementIcon_elem0"
          d="M0 0 H27 a0,0 0 0 1 0,0 V26 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Vector_20_28Stroke_29"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10023 8.53295C6.10023 12.6418 9.46945 16.0659 13.5125 16.0659C17.6904 16.0659 20.9248 12.6418 20.9248 8.53295C20.9248 4.42407 17.5556 1 13.5125 1C9.46945 1 6.10023 4.42407 6.10023 8.53295ZM7.44792 8.53295C7.44792 5.10888 10.1433 2.36963 13.5125 2.36963C16.8817 2.36963 19.5771 5.10888 19.5771 8.53295C19.5771 11.957 16.8817 14.6963 13.5125 14.6963C10.1433 14.6963 7.44792 11.957 7.44792 8.53295Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Vector_20_28Stroke_29_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.21371 25.2407C5.83133 21.5437 9.46957 19.0791 13.512 19.0791C17.5545 19.0791 21.1928 21.5438 22.8103 25.2409L22.811 25.2425L24.024 24.6946C23.9211 24.4631 23.8117 24.236 23.6963 24.0136C21.6946 20.1581 17.8442 17.7095 13.512 17.7095C9.17974 17.7095 5.32936 20.1581 3.32767 24.0136C3.21221 24.236 3.1029 24.4631 3 24.6946L4.21292 25.2425L4.21371 25.2407Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(ManagementIcon);
